import BoldSmallText from '@/components/BoldSmallText';
import RegularText from '@/components/RegularText';
import { config } from '@/config';
import { PATH } from '@/constants/path';
import { useUpdateGeneralSettingMutation } from '@/redux/query';
import { Banner, Collapsible } from '@shopify/polaris';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface Props {
  isOpen: boolean;
}

export const PricingBannerDashboard = ({ isOpen }: Props) => {
  const [isOpenBanner, setIsOpenBanner] = useState(isOpen);
  const [updateGeneralSetting] = useUpdateGeneralSettingMutation();
  const navigate = useNavigate();
  return (
    <Collapsible id={'dashboard-infor'} open={isOpenBanner}>
      <Banner
        title={'Important Pricing Update – Effective May 30th, 2025!'}
        action={{
          content: 'Grab now',
          onAction: () => navigate(PATH.PRICING),
        }}
        onDismiss={() => {
          updateGeneralSetting({
            shop: config.shop,
            showBannerOfferPricing: false,
          });
          setIsOpenBanner(false);
        }}
      >
        <RegularText>
          Starting <BoldSmallText as="span">May 30th, 2025,</BoldSmallText> we will be updating our pricing. Right now, our prices
          are still <BoldSmallText as="span">under a special promotion!</BoldSmallText> Don’t miss out on the chance to enjoy the
          current, discounted rates. Grab the old pricing before the new rates take effect!
        </RegularText>
      </Banner>
    </Collapsible>
  );
};
